import styled from 'styled-components';
import {
  Ellipse as DefaultEllipse,
  Ilustra as DefaultIlustra,
} from '~components';

export const LoadingWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing.km14};
  padding: ${({ theme }) => theme.spacing.km0}
    ${({ theme }) => theme.spacing.km10};
  display: grid;
  justify-content: center;
  justify-items: center;
  span {
    margin-top: 16px;
  }
  span:last-child {
    margin-top: 8px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    padding: ${({ theme }) => theme.spacing.km0}
      ${({ theme }) => theme.spacing.km4};
    margin-top: ${({ theme }) => theme.spacing.km12};

    span {
      margin-top: ${({ theme }) => theme.spacing.km6};
    }
  }
`;

export const Ilustra = styled(DefaultIlustra)`
  margin: auto;
  margin-top: -125px;
  display: block;
`;

export const Ellipse = styled(DefaultEllipse)`
  margin: auto;
  display: block;
  animation: rotation 2s infinite linear;

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;
